import { useRef, useState } from 'react'
import { OfferBlock } from '../../models/shared/Offer'
import { useText } from '../../context/TextContext'
import BlockToolbar from './BlockToolbar'
import { Deal } from '../../models/shared/Deal'
import { PATHS, QUERY_PARAMS } from '../../utils/shared/constants'
import { AdvancedButton } from '../AdvancedButton'
import OrgCustomerCard from '../OrgCustomerCard'

interface Props {
    block: OfferBlock;
    deal: Deal;
    readOnly?: boolean;
    onBlockUpdate: (updatedBlock: OfferBlock) => void;
    onBlockDelete: () => void;
    onMoveUp?: () => void;
    onMoveDown?: () => void;
}

export default function BlockOrgCustomer(props: Props) {
    const { onBlockDelete } = props;
    const [showToolbar, setShowToolbar] = useState(false);
    const text = useText();
    const contentRef = useRef<HTMLDivElement>(null);
    const customerEditLink = props.deal?.customerId
        ? `${PATHS.CUSTOMERS_EDIT}/${props.deal.customerId}`
        : `${PATHS.DEALS}/${props.deal.id}`;

    return (
        <div
            ref={contentRef}
            className="position-relative w-100"
            onClick={() => !props.readOnly && setShowToolbar(true)}
        >
            <BlockToolbar
                contentRef={contentRef}
                onDelete={onBlockDelete}
                onMoveUp={props.onMoveUp}
                onMoveDown={props.onMoveDown}
                showToolbar={showToolbar}
                setShowToolbar={setShowToolbar}
                readOnly={props.readOnly}
            >
                <AdvancedButton
                    variant="clean"
                    size="sm"
                    icon='bi-building'
                    link={`${PATHS.ORGANIZATIONSETTINGS}?${QUERY_PARAMS.BACK}=true`}
                >
                    {text.editOrganization}
                </AdvancedButton>
                <AdvancedButton
                    variant="clean"
                    size="sm"
                    icon='bi-person'
                    link={customerEditLink}
                >
                    {text.editCustomer}
                </AdvancedButton>
            </BlockToolbar>

            <OrgCustomerCard deal={props.deal} />
        </div>
    );
}
